import { cartClient } from '../common/cartClient';
import type {
  CapturePaypalOrderRequest,
  CapturePaypalOrderResponse,
  CreatePaymentIntentRequest,
  CreatePaymentIntentResponse,
  CreatePaypalOrderRequest,
  CreatePaypalOrderResponse,
  PaypalRecoveryResponse,
  UpdatePaymentIntentRequest,
  UpdatePaymentIntentResponse,
} from './utils/types';

export const paymentAPIClient = {
  /**
   * Create Stripe payment intent
   */
  createPaymentIntent: async (params: CreatePaymentIntentRequest): Promise<CreatePaymentIntentResponse> =>
    cartClient.post('/payment/stripe/paymentIntent', params).then((res) => res.data),
  updatePaymentIntent: async (params: UpdatePaymentIntentRequest): Promise<UpdatePaymentIntentResponse> =>
    cartClient.put('/payment/stripe/paymentIntent', params).then((res) => res.data),
  createPaypalOrder: async ({
    wooCommerceOrderId,
    orderKey,
  }: CreatePaypalOrderRequest): Promise<CreatePaypalOrderResponse> =>
    cartClient
      .post('/paypal/orders', { wooCommerceOrderId }, { headers: { 'X-WC-Order-Token': orderKey } })
      .then((res) => res.data),
  capturePaypalOrder: async ({
    paypalOrderId,
    wooCommerceOrderId,
    orderKey,
  }: CapturePaypalOrderRequest): Promise<CapturePaypalOrderResponse> =>
    cartClient
      .post(
        `/paypal/orders/${encodeURIComponent(paypalOrderId)}/capture`,
        { wooCommerceOrderId },
        { headers: { 'X-WC-Order-Token': orderKey } },
      )
      .then((res) => res.data),
  recoverPaypalOrder: async (): Promise<PaypalRecoveryResponse | null> =>
    cartClient
      .post('/paypal/orders/recovery', undefined, {
        headers: { 'X-PayPal-Recovery-Intent': 'reconcile' },
      })
      .then((res) => (res.status === 204 ? null : res.data)),
  acknowledgePaypalRecovery: async (): Promise<void> =>
    cartClient
      .delete('/paypal/orders/recovery', {
        headers: { 'X-PayPal-Recovery-Intent': 'acknowledge' },
      })
      .then(() => undefined),
  // fetch('/api/checkout-sessions', {
  //   method: 'POST',
  //   body: JSON.stringify(params),
  // })
  //   .then((response) => response.json())
  //   .then((json) => json.checkoutSessionClientSecret),
};
